import Cookies from 'js-cookie';
import {environment} from '@/commons/configs/Config';

export function getToken() {
    return Cookies.get(environment.tokenName);
}
export async function getMinecraftOther(id) {
    let token = Cookies.get(environment.tokenName);
    const result = fetch(environment.apiUrlOne + '/details/minecraft/' + id, {
        method: 'GET',
        headers: {
            'Authorization': token
        }
    })

    return await result
}

export async function getTwitchOther(id) {
    let token = Cookies.get(environment.tokenName);
    const result = fetch(environment.apiUrlOne + '/details/twitch/' + id, {
        method: 'GET',
        headers: {
            'Authorization': token
        }
    })

    return await result
}

export async function getTelegramOther(id) {
    let token = Cookies.get(environment.tokenName);
    const result = fetch(environment.apiUrlTwo + '/telegram/get/' + id, {
        method: 'GET',
        headers: {
            'Authorization': token
        }
    })

    return await result
}
export async function isMinecraft(r) {
    if (r.status === 200) {
        return true;
    } else {
        return false;
    }
}